import { AbstractControl, FormGroup } from '@angular/forms';

export interface QModelParameterValidator {
  validParameter: boolean;
}

export function validateQModelParameter(control: AbstractControl): QModelParameterValidator | null {
  const group = control as FormGroup<{ key: any; value: any }>;
  if (!!group.controls.key.value && !group.controls.value.value) {
    return { validParameter: false };
  }
  if (!!group.controls.value.value && !group.controls.key.value) {
    return { validParameter: false };
  }
  return null;
}
